const Colors =
{
LIGHTGRAY: '#E8E8E8',
MIDGRAY: '#A5A5A5',
DARKGRAY: '#333333',
YELLOW: '#FFC40C',
MIDBLUE: '#4EBDEF',
LTBLUE: '#D2EEFB',
WHITE: '#FFFFFF',
LinkBlue:"#3CB5A5"
}
export default Colors;